import * as T from "./effect";
import { pipeable as P } from "fp-ts";
export function access(sp) {
    const derived = {};
    const a = sp[specURI];
    for (const s of Reflect.ownKeys(a)) {
        derived[s] = {};
        for (const k of Object.keys(a[s])) {
            if (typeof a[s][k] === "function") {
                derived[s][k] = (...args) => T.accessM((r) => r[s][k](...args));
            }
            else {
                derived[s][k] = T.accessM((r) => r[s][k]);
            }
        }
    }
    return derived;
}
export const specURI = "@matechs/effect/freeEnv/specURI";
export function define(m) {
    return { [specURI]: m };
}
export function cn() {
    return {};
}
export function fn() {
    // tslint:disable-next-line: no-empty
    return (() => { });
}
export function providing(s, a, env) {
    const r = {};
    for (const sym of Reflect.ownKeys(s[specURI])) {
        r[sym] = {};
        for (const entry of Object.keys(s[specURI][sym])) {
            if (typeof a[sym][entry] === "function") {
                r[sym][entry] = (...args) => T.provideSO(env)(a[sym][entry](...args));
            }
            else if (typeof a[sym][entry] === "object") {
                r[sym][entry] = T.provideSO(env)(a[sym][entry]);
            }
        }
    }
    return r;
}
export function implement(s) {
    return (i) => (eff) => T.accessM((e) => P.pipe(eff, T.provideS(providing(s, i, e))));
}
export function implementWith(w) {
    return (s) => (i) => (eff) => T.effect.chain(w, (r) => T.accessM((e) => P.pipe(eff, T.provideS(providing(s, i(r), e)))));
}
export function instance(_) {
    return (m) => m;
}
export function merge(s) {
    const m = {
        [specURI]: {}
    };
    for (const k of Reflect.ownKeys(s)) {
        m[specURI] = Object.assign(Object.assign({}, m[specURI]), s[k][specURI]);
    }
    return m;
}
export const opaque = () => (_) => _;
